import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const AwarenessContent = ({ message, campaign, onJoin }) => {
  const [hasJoined, setHasJoined] = useState(false);

  const handleJoin = () => {
    setHasJoined(true);
    if (onJoin) {
      onJoin();
    }
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0 bg-secondary/10">
          <Icon name="Heart" size={24} color="var(--color-secondary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-3 md:mb-4">
            Sosyal Farkındalık
          </h3>
          <div className="p-6 md:p-8 lg:p-10 rounded-xl bg-gradient-to-br from-secondary/5 to-primary/5 border border-border">
            <p className="text-base md:text-lg lg:text-xl text-foreground leading-relaxed mb-4 md:mb-5">
              {message || 'Her yıl binlerce insan trafik kazalarında hayatını kaybediyor. Güvenli sürüş sadece bir tercih değil, bir sorumluluktur.'}
            </p>
            <div className="flex items-start gap-3 p-4 md:p-5 rounded-lg bg-card">
              <Icon name="Target" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-2">
                  {campaign || 'Güvenli Trafik Kampanyası'}
                </h4>
                <p className="text-sm md:text-base text-muted-foreground">
                  Bu kampanyaya katılarak farkındalık yaratmaya destek ol
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <Button
          variant={hasJoined ? 'success' : 'default'}
          size="lg"
          fullWidth
          onClick={handleJoin}
          disabled={hasJoined}
          iconName={hasJoined ? 'CheckCircle' : 'Users'}
          iconPosition="left"
        >
          {hasJoined ? 'Kampanyaya Katıldın' : 'Katılıyorum'}
        </Button>

        {hasJoined && (
          <div className="text-center">
            <p className="text-sm md:text-base text-success flex items-center justify-center gap-2">
              <Icon name="Heart" size={16} />
              Desteğin için teşekkürler! Birlikte fark yaratabiliriz.
            </p>
          </div>
        )}

        <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Users" size={16} />
          <span>{Math.floor(Math.random() * 5000) + 1000} kişi bu kampanyaya katıldı</span>
        </div>
      </div>
    </div>
  );
};

export default AwarenessContent;